<div class="input-group input-group-data">
  <input type="time" [ngModel]="time" [disabled]="disabled" (ngModelChange)="onChange($event)" class="form-control">
</div>